export default "__VITE_ASSET__ef820617__"